export default {"src":"/org/_next/static/media/copy.5505c06e.svg","height":17,"width":15,"blurWidth":0,"blurHeight":0};